import { IFailedTakeAction, ISystem, IEClaims } from "Model/ServerResponse";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  DeleteApprovals,
  PostDeleteApprovals,
  reCalculateSelectedApproval,
  SelectedApprovalSelector,
  setIsTabletView,
  setSelectedApproval,
} from "Store/AccessApprovals/AccessApprovalsSlice";
import { ListDetailsView } from "../../ListDetailsView/ListDetailsView";
import { TakeActionFailedModal } from "../../Modals/TakeActionFailedModal/TakeActionFailedModal";
import { useAppDispatch } from "Store/store";
import { IAccessApprovals } from "Model/ServerResponse/IAccessApprovals";
import { AccessApprovalsActions } from "../AccessApprovalsActions/AccessApprovalsActions";
import { AccessApprovalsListView } from "../AccessApprovalsListView/AccessApprovalsListView";
import { AccessApprovalsDetailsCard } from "../AccessApprovalsDetailsCard/AccessApprovalsDetailsCard";

export interface IAccessApprovalsPageProp {
}

export function AccessApprovalsPage(props: IAccessApprovalsPageProp) {

    let appDispatch = useAppDispatch();

  let selectedApproval = useSelector(SelectedApprovalSelector);

  let [takeActionFailedModalOpen, setTakeActionFailedModalOpen] =
    useState<boolean>(false);
  let [failedTakeActions, setFailedTakeActions] =
    useState<IFailedTakeAction[]>([]);

  return (
    <div>
      {takeActionFailedModalOpen && (
        <TakeActionFailedModal
          open={takeActionFailedModalOpen}
          failedActions={failedTakeActions}
          onOk={(e: any) => setTakeActionFailedModalOpen(false)}
          onContinue={handleContinue} // New prop for continue button
        />
      )}
      <ListDetailsView
        selectedApproval={selectedApproval}
        onBackClick={handleBackClick}
        onWindowSizeChange={handleWindowSizeChange}
        listView={listUI}
        detailsView={detailsUI}
      />
    </div>
  );

  
  function listUI(){
    return (
        <AccessApprovalsListView getActionsUI={actionsUI} />
    );
  }

  function detailsUI(){
    return (
        <AccessApprovalsDetailsCard getActionsUI={actionsUI} />
    );
  }

  function actionsUI(
    _isMulti: boolean,
    _approvals: IAccessApprovals[],
  ) {
    return (
        <AccessApprovalsActions
          isMulti={_isMulti}
          count={_approvals.length}
          onApprove={handleOnApprove}
          onReject={handleOnReject}
        />
    );
  }

  function handleBackClick(e: any) {
    appDispatch(setSelectedApproval(null));
  }

  function handleWindowSizeChange(e: any, isTabletView: boolean) {
    appDispatch(setIsTabletView(isTabletView));
    appDispatch(reCalculateSelectedApproval());
  }

  function handleOnApprove(e: any, isMulti: boolean, comment: string) {
    takeAction(true, isMulti, comment);
  }

  function handleOnReject(e: any, isMulti: boolean, comment: string) {
    takeAction(false, isMulti, comment);
  }

 async function takeAction(isApprove: boolean, isMulti: boolean, comment: string, isConfirmed: boolean = false): Promise<void> {
    let result = ((await appDispatch(PostDeleteApprovals({ isApprove: isApprove, isMulti: isMulti, comment: comment, getRequestBody: (approval: ISystem) => getTakeActionRequestBody(approval, comment, isApprove, isConfirmed) }))).payload) as { passedApprovals: IAccessApprovals[], failedTakeActions: IFailedTakeAction[] };
    if (result.failedTakeActions.length > 0) {
      //Some approvals failed
      setTakeActionFailedModalOpen(true);
      setFailedTakeActions(result.failedTakeActions);
    }

    //Remove cards & subtract count for passed
    appDispatch(DeleteApprovals(result.passedApprovals));
  }

  function getTakeActionRequestBody(_approval: ISystem, _comment: string, isApprove: boolean, isConfirmed: boolean): any {
    let _accessApprovals = _approval as IAccessApprovals;
    return {
      approvalId: _accessApprovals.id.toString(),
      comment: _comment,
      extra: {
        actionId: isApprove ? 2 : 3,
        actionTakenOn: new Date().toISOString(),
        approverTypeId: 2,
        isConfirmed: isConfirmed // Set isConfirmed based on the parameter
      }
    }
  }

  async function handleContinue(e: any) {
    setTakeActionFailedModalOpen(false);
    await takeAction(true, false, "", true); // Call takeAction with isConfirmed: true
  }

  

}
